"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleToggle = void 0;
const react_1 = __importDefault(require("react"));
const Toggle_styled_1 = require("./Toggle.styled");
const MultipleToggle = ({ values, render = (value) => react_1.default.createElement(Toggle_styled_1.ValueStyled, null,
    " ",
    value,
    " "), selectedValue, onSelect, full, disabled, dataTestId, }) => (react_1.default.createElement(Toggle_styled_1.ToggleWrapperMultipleStyled, { full: full, disabled: disabled, "data-test": "toggle", "data-test-id": dataTestId },
    react_1.default.createElement(Toggle_styled_1.TextValuesMultipleStyled, null, values.map((value, index) => (react_1.default.createElement(Toggle_styled_1.ValueWrapperMultipleStyled, { selected: value === selectedValue, "data-test": "multiple_toggle_value", "data-test-id": `toggle-value-${value === selectedValue ? 'selected' : 'unselected'}`, "data-test-value": value, key: index, onClick: () => onSelect(value) }, render(value)))))));
exports.MultipleToggle = MultipleToggle;
